/**
 * Converts a report type code (e.g., 'SUMMARY', 'PERMISSIONS', 'DETAIL') to a user-friendly label.
 * @param reportType - The report type code to format
 * @returns Title-cased label for display
 */
export default function formatReportType(reportType: string): string {
  switch (reportType) {
    case 'SUMMARY':
      return 'Summary Report';
    case 'PERMISSIONS':
      return 'Permissions Report';
    case 'DETAIL':
      return 'Detail Report';
    default:
      return reportType;
  }
}
